import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _ExecuteKpis, _Kpi } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProccessTypeConstants } from "../../../erp/cellEditor/CashRequest/FactoryDocument/SelectProccessTypeConstants";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";
import { InputDate } from "../../../theme/Input/InputDate";
import { StrategicObjectiveEditor } from "../StrategicObjetive/StrategicObjective.editor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { AccountEditor } from "../../../editor/AccountEditor";

import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";

import { StrategicObjectiveEditortwo } from "../StrategicObjetive/StrategicObjectiveEditortwo";
import { KpiConstantTypes } from "../Kpi/KpiConstantTypes";
import { KpiConstantMeasurement } from "../Kpi/KpiConstantMeasurement";
import { DayConstantList } from "../Kpi/DayConstantList";

interface Props {
    idDashBoard: number;
}
export const KpiByDashBoard = ({ idDashBoard }: Props) => {

    const Kpi = useDataBean(_Kpi);
    const single = Singleton.getInstance();
    const [form, setForm] = useState<any>({
        IDStrategicObjective: null,
        Name: null,
        IDLnFunctionalID: null,
        Account: null
    })
    const executeKpis = useDataBean(_ExecuteKpis);
    const [lista, setLista] = useState<any>([]);
    const [processType, setprocessType] = useState<number>(null)
    const [modalkpimed, setModalkpimed] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalkpirang, setModalkpirang] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [regexStr, setregexStr] = useState<any>(null)
    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [idDashBoard, paginador.page])

    const getLista = () => {

        Kpi.instance.getKpiCatalogByDash(idDashBoard, processType, form.IDStrategicObjective, form.IDLnFunctionalID, form.Account, null, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.StrategicObjName = (user.DataBeanProperties.StrategicObjectiveName ?? "") + "-" + (user.DataBeanProperties.StrategicObjectiveDescription ?? "");
                        user.DataBeanProperties.NameArea = (user.DataBeanProperties.FunctionalIDJsonCode ?? "") + "-" + (user.DataBeanProperties.FunctionalIDName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        Kpi.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        Kpi.instance.deleteKpi(Kpi.bean.IDKpi).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {

        Kpi.instance.updateKpi(Kpi.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const ExecuteKpis = () => {

        executeKpis.instance.executeKpis(Kpi.bean.FromDate, Kpi.bean.IDKpi, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModalkpimed({ ...modalkpimed, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const ExecuteKpisTWO = () => {

        executeKpis.instance.executeKpisRange(Kpi.bean.FromDate, Kpi.bean.UptoDate, Kpi.bean.IDKpi, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModalkpirang({ ...modalkpirang, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDKpi', visible: true },
        { title: 'Objetivo Estratégico', property: 'StrategicObjName', visible: true },
        { title: 'Area Organizacional', property: 'NameArea', visible: true },
        { title: 'Tipo', property: 'Type', visible: true },
        { title: 'Tipo Medición', property: 'MeasurementTypeName', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Responsable del Indicador', property: 'AccountName', visible: true },
        { title: 'Fecha Creacion', property: 'Since', visible: true },
        { title: 'Última Actualización', property: 'LastUpdate', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ejecutar Medición KPI', icono: 'ri-inbox-unarchive-line', visible: single.canDelete(), evento: () => { setModalkpimed({ ...modalkpimed, "view": true }) } },
            { titulo: 'Ejecutar Medición KPI en un rango', icono: 'ri-inbox-unarchive-fill', visible: single.canDelete(), evento: () => { setModalkpirang({ ...modalkpirang, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${Kpi.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Lista de Indicadores KPI">
            <div className="row">
                <div className="col-md-6">
                    <SelectProccessTypeConstants idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                </div>
                <div className="col-md-6">
                    <StrategicObjectiveEditortwo render={form.Name} idSelector={form.IDStrategicObjective} onChange={(e) => { setForm({ ...form, "IDStrategicObjective": e.IDStrategicObjective, "Name": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <SelectFunctionalID label='Area Organizacional' functionalIDLn={form.IDLnFunctionalID} onChange={(e: any) => { setForm({ ...form, "IDLnFunctionalID": e.IDLn }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={form.Account} onChange={(e: any) => { setForm({ ...form, "Account": e.IDAccount }) }} label="Responsable del Indicador" />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Consultar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={Kpi.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectProccessTypeConstants idSelector={Kpi.bean.ProcessType} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <StrategicObjectiveEditortwo render={Kpi.bean.StrategicObjectiveName} idSelector={Kpi.bean.IDStrategicObjective} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "IDStrategicObjective": e.IDStrategicObjective, "StrategicObjectiveName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <SelectFunctionalID label='Area Organizacional' functionalIDLn={Kpi.bean.IDLnFunctionalID} onChange={(e: any) => { Kpi.setBean({ ...Kpi.bean, "IDLnFunctionalID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-6">
                                <KpiConstantTypes idSelector={Kpi.bean.Type} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "Type": e }) }} />
                            </div>
                            {Kpi.bean.Type === 2 && (
                                <div className="row">
                                    <div className="col-md-12 mt-3">
                                        <label>SQL Query</label>
                                        <textarea
                                            name="SQLQuery"
                                            className="form-control"
                                            value={Kpi.bean.SQLQuery}
                                            onChange={Kpi.handleChange}
                                        />
                                    </div>
                                </div>
                            )}

                            {Kpi.bean.Type === 6 && (
                                <div className="row">
                                    <div className="col-md-12 mt-3">
                                        <label>Class For Name</label>
                                        <textarea
                                            name="ClassForName"
                                            className="form-control"
                                            value={Kpi.bean.ClassForName}
                                            onChange={Kpi.handleChange}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="col-md-6">
                                <KpiConstantMeasurement idSelector={Kpi.bean.MeasurementType} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "MeasurementType": e }) }} />
                            </div>
                            {Kpi.bean.MeasurementType === 10 && (
                                <div className="row">
                                    <div className="col-md 6">
                                        <MonthEditorbyconst idSelector={Kpi.bean.Month} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "Month": e }) }} />
                                    </div>
                                    {Kpi.bean.Month && <>

                                        <div className="col-md-6">
                                            <DayConstantList month={Kpi.bean.Month} idSelector={Kpi.bean.DayOfMonth} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "DayOfMonth": e }) }} />
                                        </div>
                                    </>}
                                    <div className="col-md-6">
                                        <label>Nombre</label>
                                        <input type="text" name="TimeDays" className="form-control" value={Kpi.bean.TimeDays} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "TimeDays": e }) }} />
                                    </div>
                                </div>
                            )}
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={Kpi.bean.Name} onChange={Kpi.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={Kpi.bean.IDAccountResponsible} onChange={(e) => { Kpi.setBean({ ...Kpi.bean, "IDAccountResponsible": e.IDAccount }) }} label="Responsable del Indicador" />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={Kpi.bean.Description} onChange={Kpi.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalkpimed} updateModal={setModalkpimed} eventModal={ExecuteKpis}>
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="FromDate" label="Fecha Ejecución" value={Kpi.bean.FromDate} setDate={(e: any) => { Kpi.setBean({ ...Kpi.bean, "FromDate": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalkpirang} updateModal={setModalkpirang} eventModal={ExecuteKpisTWO}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="FromDate" label="Fecha de inicio" value={Kpi.bean.FromDate} setDate={(e: any) => { Kpi.setBean({ ...Kpi.bean, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="UptoDate" label="Fecha hasta" value={Kpi.bean.UptoDate} setDate={(e: any) => { Kpi.setBean({ ...Kpi.bean, "UptoDate": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {Kpi.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}